import onboarding from './onboarding';

export const onBoardingActions = onboarding.actions;
export const onBoardingReducer = onboarding.reducer;
